import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function ProgressBar({ 
  value, 
  max = 100,
  size = 'md',
  variant = 'primary',
  showLabel = true,
  className = ''
}) {
  const percentage = Math.round((value / max) * 100);
  
  const sizes = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };
  
  const variants = {
    primary: 'bg-violet',
    success: 'bg-spring-green',
    error: 'bg-bittersweet',
    info: 'bg-sky-blue'
  };

  return (
    <div className="space-y-1">
      {showLabel && (
        <div className="flex justify-between text-sm text-ebony">
          <span>Progress</span>
          <span>{percentage}%</span>
        </div>
      )}
      <div className={twMerge('w-full bg-light-purple rounded-full overflow-hidden', className)}>
        <div 
          className={twMerge(
            'transition-all duration-500 ease-out rounded-full',
            sizes[size],
            variants[variant]
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}